
import { Options, Vue } from "vue-class-component";
import TabsCSV from "./component/csv/tabs-csv.vue";
import TabsUrsa from "./component/ursa/tabs-ursa.vue";
import { FlagsNetwork } from "@/feature-flags/flags-network";

@Options({
  components: {
    TabsCSV,
    TabsUrsa
  },
  beforeRouteEnter(to: any, from: any, next: any) {
    if (from.name === "detail-location-ursa") {
      return next((vm: any) => {
        vm.tabFromRouter = "TabsUrsa";
      })
    }
    next();
  }
})
export default class OperationalArea extends Vue {
  // Tabs
  get tabs() {
    return [
      {
        name: "TabsCSV",
        title: "Daftar CSV",
        permission: FlagsNetwork.list_csv_enable.isEnabled()
      },
      {
        name: "TabsUrsa",
        title: "Daftar Ursa",
        permission: FlagsNetwork.list_ursa_code_enable.isEnabled()
      }
    ].filter((tab) => tab.permission);
  }
  currentTab = "TabsCSV";
  tabFromRouter = "";

  changeTabs(value: string) {
    this.currentTab = value;
  }

  mounted() {
    this.currentTab = this.tabFromRouter || this.tabs[0].name;
  }
}
